<template>
  <Transition>
    <LoaderWindow v-if="loading" />
  </Transition>
  <RouterView />
</template>

<script setup>
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { RouterView } from 'vue-router'
import { computed, onMounted, watch } from 'vue'
import LoaderWindow from '@/components/LoaderWindow.vue'

const store = useStore()
const { locale } = useI18n()
const loading = computed(() => store.getters.loading)
const selectedLocale = computed(() => store.getters.locale)

const savedLocale = localStorage.getItem('locale')
if (savedLocale !== selectedLocale.value) store.dispatch('setLocale', savedLocale)

locale.value = savedLocale

watch(selectedLocale, (newLocale) => {
  if (locale.value !== newLocale) {
    locale.value = newLocale
  }
}, { immediate: true })

onMounted(() => {
  const savedLocale = localStorage.getItem('locale')
  if (savedLocale) {
    if (selectedLocale.value !== savedLocale) store.dispatch('setLocale', savedLocale)
    if (locale.value !== savedLocale) locale.value = savedLocale
  }

  store.dispatch('checkVisitTime')

  const supportedLocales = ['ru', 'uz', 'en']
  const savedAskLocale = localStorage.getItem('askLocale')

  if (!savedAskLocale) {
    const browserLang = (navigator.language || 'ru').split('-')[0]
    if (supportedLocales.includes(browserLang)) store.dispatch('setAskLocale', 'hide')
  }
})

</script>
